import React from "react";
import { Modal, SendToast, Text } from "@networkraildigitalfactory/components";
import { useHistory } from "react-router-dom";
import { useUsers } from "../../hooks/useAPI";
import useDisableScroll from "../../hooks/useDisableScroll";

const RemoveEmployeeModal = (props) => {
  const { show, close, employeeData, user, setIsLineManager } = props;
  const history = useHistory();
  const [{ error }, executeAction] = useUsers(
    {
      url: employeeData && employeeData.email,
      method: "PUT",
    },
    { manual: true }
  );

  const removeEmailFromEmployee = async () => {
    let data = {};
    if (user.email === employeeData.lineManager) {
      data.lineManager = null;
    } else if (user.email === employeeData.additionalLM) {
      data = {
        fullName: employeeData.fullName,
        email: employeeData.email,
        jobTitle: employeeData.jobTitle,
        empNo: employeeData.empNo,
        lineManager: employeeData.lineManager,
        additionalLM: null,
      };
    }
    await executeAction({
      data,
    });
    if (error) {
      SendToast(`There was a problem removing ${employeeData.fullName} from your team.`, "error");
    } else {
      close();
      SendToast(`${employeeData.fullName} was successfully removed from your team.`, "success");
      await setIsLineManager();
      history.push("/my-team");
    }
  };
  useDisableScroll(show);

  return (
    <Modal
      type="confirm"
      cancelText="No"
      cancelButtonColor="red"
      confirmText="Yes"
      confirmButtonColor="blue"
      show={show}
      onClose={close}
      onConfirm={removeEmailFromEmployee}
      style={{ maxWidth: "90%", width: "690px", top: "5vh", position: "fixed" }}
      focusOnClose="removeEmployee"
    >
      <div>
        <Text
          wrapper="h1"
          type="header"
          style={{ marginBottom: "2rem", ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Are you sure?
        </Text>
        <Text
          wrapper="p"
          type="body"
          color="#000000"
          style={{ ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          {employeeData && employeeData.fullName} will be removed from your team view and will need
          to add a new line manager to their profile.
        </Text>
      </div>
    </Modal>
  );
};

export default RemoveEmployeeModal;
